import { Parser } from 'expr-eval-fork';

const expressionParser = new Parser();

/**
 * A safe parser around expr-eval-fork that catches
 *  exceptions and returns results as values.
 */
export function evaluateExpression(
  expression: string
): {
  expression: string;
} & (
  | {
      success: false;
      evaluatedValue?: never;
    }
  | {
      success: true;
      evaluatedValue: number;
    }
) {
  try {
    const parsedValue = expressionParser.parse(expression).evaluate();

    return {
      success: true,
      evaluatedValue: parsedValue as number,
      expression: expression,
    };
  } catch (error) {
    return {
      expression: expression,
      success: false,
    };
  }
}

/**
 * A light weight input validator that prevents the most basic unser input errors like:
 *  - prevent back to back operators like 2 ++ 2 or 2..3
 *
 * Feel free to remove it if it's causing issues.
 */
export function validateInputChange(value: string): boolean {
  if (value.length === 0) {
    throw Error(
      `I'm not supposed to handle empty strings, deal with it before passing it to me.`
    );
  }

  value = value.trim();

  if (value === '') {
    return false;
  }

  const validCharactersRegex = /^[0-9+\-*/.() ]+$/;

  const lastCharacter = value[value.length - 1];
  if (!validCharactersRegex.test(lastCharacter)) {
    return false;
  }

  const secondLastCharacter =
    value.length > 1 ? value[value.length - 2] : undefined;

  if (secondLastCharacter !== undefined) {
    if (['+', '-', '*', '/', '.'].includes(lastCharacter)) {
      if (lastCharacter === secondLastCharacter) {
        return false;
      }
    }
  }

  return true;
}
